const TRANSLATION_KEYS = {
  SIDEBAR: {
    MAIN: "SIDEBAR.MAIN",
    ADMIN_PERMISSIONS: "SIDEBAR.ADMIN_PERMISSIONS",
  },
  ADMIN: {
    USERS_WITH_ACCESS: "ADMIN.USERS_WITH_ACCESS",
    PERMISSIONS: "ADMIN.PERMISSIONS",
    PERMISSION_USERS: "ADMIN.PERMISSION_USERS",
    ADD_USER: "ADMIN.ADD_USER",
    REMOVE_USER: "ADMIN.REMOVE_USER",
    SEARCH_USERS: "ADMIN.SEARCH_USERS",
    USERS: "ADMIN.USERS",
    USERS_WITH_PERMISSION: "ADMIN.USERS_WITH_PERMISSION",
    PERMISSIONS_MANAGEMENT: "ADMIN.PERMISSIONS_MANAGEMENT",
    CURRENT_USERS: "ADMIN.CURRENT_USERS",
    NO_USERS_WITH_PERMISSION: "ADMIN.NO_USERS_WITH_PERMISSION",
    SELECT_PERMISSION: "ADMIN.SELECT_PERMISSION",
    ALL_USERS_WITH_ACCESS: "ADMIN.ALL_USERS_WITH_ACCESS",
    SEARCH_RESULTS: "ADMIN.SEARCH_RESULTS",
  },
  ACTIONS: {
    SEARCH: "ACTIONS.SEARCH",
    ADD: "ACTIONS.ADD",
    REMOVE: "ACTIONS.REMOVE",
    CONFIRM: "ACTIONS.CONFIRM",
    BACK: "ACTIONS.BACK",
  },
  AUTH: {
    VERIFY_CODE: "AUTH.VERIFY_CODE",
    ENTER_SMS_CODE: "AUTH.ENTER_SMS_CODE",
    RESEND_CODE_TIMER: "AUTH.RESEND_CODE_TIMER",
    RESEND_CODE: "AUTH.RESEND_CODE",
  },
  PROFILE: {
    USER: "PROFILE.USER",
  },
} as const;

export default TRANSLATION_KEYS;
